export default {
  meta: {
    title: '基诺浦拓店任务报表',
    url: '/report/ginoble' // 埋点用，记录所属模块
  }
};
